import { Typography } from '@euler/app/components/typography';
import { VoiceTurnState } from '@euler/components/voice-input/functions/useVoiceTurn';
import { LevelMeter } from '@euler/components/voice-input/level/LevelMeter';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { BehaviorSubject } from 'rxjs';
import { aiColors } from '../../../../../ai-suite/theme';

/** A voice turn under way: talking, or its final sentence being awaited. */
export type VoiceDraft = Exclude<VoiceTurnState, { kind: 'idle' }>;

const kFaint = 'rgba(255,255,255,0.75)';

/**
 * The trainee's line while it is spoken, where it will land: the words as
 * they are recognised under a meter of the voice, then 识别中… until the
 * final sentence replaces it with the sent line.
 */
export const TraineeDraftBubble = memo(
  ({
    draft,
    level$,
  }: {
    draft: VoiceDraft;
    level$: BehaviorSubject<number>;
  }) => {
    const { rpx } = useResponsiveContext();
    const talking = draft.kind === 'holding';
    return (
      <View
        style={{
          alignSelf: 'flex-end',
          maxWidth: '78%',
          minWidth: rpx(120),
          gap: rpx(6),
          borderRadius: rpx(22),
          borderBottomRightRadius: rpx(6),
          backgroundColor: aiColors.primary,
          opacity: talking ? 1 : 0.8,
          paddingHorizontal: rpx(14),
          paddingVertical: rpx(10),
        }}
      >
        {talking ? (
          <LevelMeter level$={level$} color={kFaint} />
        ) : (
          <Typography.Text size={rpx(11)} color={kFaint}>
            识别中…
          </Typography.Text>
        )}
        {draft.caption || talking ? (
          <Typography.Text
            size={rpx(14)}
            color={draft.caption ? aiColors.primaryForeground : kFaint}
            style={{ lineHeight: rpx(21) }}
          >
            {draft.caption || '正在听…'}
          </Typography.Text>
        ) : null}
      </View>
    );
  },
);
